import { render } from "./Qcm.vue?vue&type=template&id=67af7502&scoped=true&ts=true"
import script from "./Qcm.vue?vue&type=script&lang=ts"
export * from "./Qcm.vue?vue&type=script&lang=ts"

import "./Qcm.vue?vue&type=style&index=0&id=67af7502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67af7502"]])

export default __exports__